export default "__VITE_ASSET__D13Yy_Bk__"